<template>
  <div>
    <NavigationBar titel="Personal" :actions="actions"></NavigationBar>
    <section>
      <TippCard
        hintID="Mitgliederverwaltung_Personal_1_V1"
        text="Für jeden Benutzer kann ein Mitgliedsprofil erstellt werden, um die Mitgliederverwaltung des Personals zu organisieren. Jeder Benutzer pflegt und verwaltet seinen Eintrag grundsätzlich selbstständig. Je nach Einstellung können für Einträge Genehmiger festgelegt werden. Bei Änderung des Eintrags wird die festgelegte Person/-gruppe informiert und eine Genehmigung des Eintrages eingefordert."
      >
      </TippCard>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader icon="mdi-account-details" title="Mitglieder">
                <template v-slot:actions>
                  <v-btn-toggle dense v-model="viewMode" mandatory>
                    <v-btn outlined icon value="list">
                      <v-icon
                        :color="$vuetify.theme.dark ? '' : 'grey darken-1'"
                        >mdi-view-list</v-icon
                      >
                    </v-btn>
                    <v-btn depressed outlined icon value="table">
                      <v-icon
                        :color="$vuetify.theme.dark ? '' : 'grey darken-1'"
                        >mdi-table</v-icon
                      >
                    </v-btn>
                    <v-btn outlined icon value="birthday">
                      <v-icon
                        :color="$vuetify.theme.dark ? '' : 'grey darken-1'"
                        >mdi-cake-variant</v-icon
                      >
                    </v-btn>
                  </v-btn-toggle>
                </template>
              </Subheader>
              <div v-if="viewMode === 'list'" class="mt-7">
                <personnel-records-list
                  :personnelRecords="records"
                ></personnel-records-list>
              </div>
              <div v-else-if="viewMode === 'table'" class="mt-7">
                <personnel-records-data-table
                  :personnelRecords="records"
                ></personnel-records-data-table>
              </div>
              <div v-else-if="viewMode === 'birthday'" class="mt-7">
                <v-row>
                  <v-col cols="12">
                    <v-card v-if="divisionsLegend.length > 0">
                      <v-card-title class="subtitle-2 pb-2">
                        Abteilungen
                      </v-card-title>
                      <v-card-text class="pt-0">
                        <v-chip
                          v-for="division in divisionsLegend"
                          :key="division.id"
                          :color="division.color"
                          class="mr-1 my-1 font-weight-medium"
                          small
                          dark
                        >
                          <span>{{ division.title }}</span>
                        </v-chip>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="9">
                    <v-card elevation="2">
                      <v-card-title class="pb-2">
                        <span>{{ calendarMonthYear }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="previousMonth">
                          <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                        <v-btn icon @click="nextMonth">
                          <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>
                      </v-card-title>

                      <v-card-text class="pa-4">
                        <v-calendar
                          ref="calendar"
                          v-model="calendarFocus"
                          :events="birthdayEvents"
                          event-color="primary"
                          type="month"
                          :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                          locale="de"
                          locale-first-day-of-year="4"
                          show-week
                          @click:event="showBirthdayDetails"
                        ></v-calendar>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-card>
                      <v-card-title>Anstehende Geburtstage</v-card-title>
                      <v-card-text class="px-0">
                        <v-list v-if="birthdaysByWeek.length > 0" nav dense>
                          <template
                            v-for="(weekGroup, weekIndex) in birthdaysByWeek"
                          >
                            <v-subheader
                              :key="'week-' + weekIndex"
                              class="font-weight-medium my-0 py-0"
                            >
                              {{ weekGroup.weekLabel }}
                            </v-subheader>
                            <template v-for="birthday in weekGroup.birthdays">
                              <v-list-item
                                :key="birthday.user.uid"
                                @click="routeDetails(birthday)"
                              >
                                <!-- <v-list-item-avatar>
                                  <v-img
                                    v-if="birthday.photoUrl"
                                    :src="birthday.photoUrl"
                                  ></v-img>
                                  <v-icon v-else>mdi-account-circle</v-icon>
                                </v-list-item-avatar> -->
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ birthday.firstName }}
                                    {{ birthday.lastName }}
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ formatBirthdayDate(birthday.birthdate) }}
                                    <span v-if="birthday.age !== null">
                                      ({{ birthday.age }} Jahre)</span
                                    >
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                                <v-list-item-action-text
                                  v-if="
                                    birthday.division &&
                                    birthday.division.shortTitle
                                  "
                                >
                                  <v-chip
                                    small
                                    :color="
                                      divisionColors[birthday.division.id] ||
                                      'grey'
                                    "
                                    dark
                                  >
                                    {{ birthday.division.shortTitle }}
                                  </v-chip>
                                </v-list-item-action-text>
                              </v-list-item>
                              <!-- <v-divider
                                v-if="index < weekGroup.birthdays.length - 1"
                                :key="'divider-' + birthday.user.uid"
                                inset
                              ></v-divider> -->
                            </template>
                            <v-divider
                              v-if="weekIndex < birthdaysByWeek.length - 1"
                              :key="'week-divider-' + weekIndex"
                              class="my-1"
                            ></v-divider>
                          </template>
                        </v-list>
                        <div v-else class="text-center grey--text">
                          Keine anstehenden Geburtstage
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
    <section>
      <custom-dialog
        v-if="helpers.recordCreation.dialogModel"
        @close="toggleRecordCreationDialog()"
        title="Neues Mitglied anlegen"
        width="m"
        :errorMessage="helpers.recordCreation.errorMessage"
        :btnAction="startRecordCreation"
        :btnDisabled="!helpers.recordCreation.formIsValid"
        :loading="helpers.recordCreation.loading"
        btnText="Erstellen"
        fullscreenOnMobile
      >
        <template v-slot:content>
          <v-alert text color="warning" type="info">
            <div class="title">Hinweis</div>
            <div class="">
              Einträge werden automatisch für alle Mitglieder der Organisation
              erstellt. Zusätzliche Einträge sollten nur erstellt werden für
              Personen ohne eigenen Zugang/eigenes Benutzerkonto.
            </div>
          </v-alert>
          <v-form
            v-model="helpers.recordCreation.formIsValid"
            @submit.prevent="startRecordCreation()"
          >
            <personnel-record-creation-editor
              v-model="helpers.personnelRecordBaseData"
            ></personnel-record-creation-editor>
          </v-form>
        </template>
      </custom-dialog>
    </section>
    <section v-if="checkIfSupport">
      <support-tools :sources="code"></support-tools>
    </section>
  </div>
</template>

<script>
import { functions } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import SupportTools from "@/components/_system/helpers/SupportTools.vue";
import CustomDialog from "@/components/_systemwide/CustomDialog.vue";
import PersonnelRecordsDataTable from "@/components/member-management/personnel-records/PersonnelRecordsDataTable.vue";
import PersonnelRecordsList from "@/components/member-management/personnel-records/PersonnelRecordsList.vue";
import PersonnelRecordCreationEditor from "@/components/member-management/personnel-records/PersonnelRecordCreationEditor.vue";
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import {
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_create,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_read,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_GENERAL_update,
} from "@/data/permission-types.js";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { GET_PERSONNEL_RECORDS } from "@/store/action-types.js";

export default {
  name: "member-management-personnel-records",
  components: {
    NavigationBar,
    Subheader,
    PersonnelRecordsDataTable,
    PersonnelRecordsList,
    SupportTools,
    CustomDialog,
    PersonnelRecordCreationEditor,
    TippCard,
  },
  data() {
    return {
      viewMode: "table", // 'grid', 'table', or 'birthday'
      search: "",
      calendarFocus: new Date().toISOString().substr(0, 10),
      groupBySelector: {
        value: "division.title",
        label: "Abteilung",
      },
      activeDataView: "active",
      dataViews: [
        { text: "Alle", value: "all" },
        { text: "Aktiv", value: "active" },
        { text: "Beurlaubt", value: "onLeave" },
        { text: "Im Übertritt", value: "transfer" },
        { text: "Ausgetreten", value: "resigned" },
        { text: "Entlassen", value: "dismissed" },
        { text: "Verstorben", value: "deceased" },
      ],
      groupByItems: [
        { text: "Abteilung", value: "division.title", icon: "mdi-home-group" },
        {
          text: "Dienstgrad",
          value: "rank.title",
          icon: "mdi-chevron-double-up",
        },
        {
          text: "Dienststellung",
          value: "dutyPosition.title",
          icon: "mdi-account-tie",
        },
        { text: "Status", value: "status", icon: "mdi-account-check" },
      ],
      footerProps: {
        "items-per-page-options": [15, 25, 50, -1],
      },
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_create}`,
          actionStyle: "textBtn",
          function: this.toggleRecordCreationDialog,
        },
        {
          title: "Sammeleingabe",
          icon: "mdi-table-edit",
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_GENERAL_update}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "member-management-personnel-records-bulk-edit",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          },
        },
        {
          title: "Ansichten",
          icon: "mdi-view-grid-outline",
          actionStyle: "textBtnMultiple",
          list: [
            {
              title: "Detailansicht",
              subtitle: "Listenansicht",
              icon: "mdi-dock-left",
              disabled: true,
              function: () => {
                /* zur Master-Detail-Ansicht */
              },
            },
            {
              title: "Split-Screen",
              icon: "mdi-view-split-vertical",
              permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_read}`,
              actionStyle: "textBtn",
              function: () => {
                this.$router.push({
                  name: "member-management-personnel-records-split-screen",
                });
              },
            },
          ],
        },
        { divider: true },
        { actionStyle: "clipboardBtn" },
      ],
      helpers: {
        recordCreation: {
          dialogModel: false,
          loading: false,
          formIsValid: false,
          errorMessage: "",
        },
        personnelRecordBaseData: {
          firstName: null,
          lastName: null,
          personnelNumber: null,
          status: null,
          division: null,
        },
      },
    };
  },
  computed: {
    records() {
      return this.$store.state.memberManagement.personnelRecords;
    },
    checkIfSupport() {
      return this.$store.getters["organization/checkIfSupport"];
    },
    code() {
      return [{ title: "records", data: this.records }];
    },
    divisionColors() {
      // Define color palette for divisions
      const colors = [
        "teal darken-3",
        "purple darken-3",
        "indigo darken-3",
        "blue darken-3",
        "amber darken-3",
      ];

      // Create a map of division IDs to colors
      const divisionColorMap = {};
      const divisions = [
        ...new Set(
          this.records
            .filter((r) => r.division && r.division.id)
            .map((r) => r.division.id),
        ),
      ];

      divisions.forEach((divId, index) => {
        divisionColorMap[divId] = colors[index % colors.length];
      });

      return divisionColorMap;
    },

    birthdayEvents() {
      const currentYear = new Date().getFullYear();
      return this.records
        .filter((record) => record.birthdate)
        .map((record) => {
          const birthDate = record.birthdate.toDate
            ? record.birthdate.toDate()
            : new Date(record.birthdate);

          // Assign color based on division
          const color =
            record.division && record.division.id
              ? this.divisionColors[record.division.id] || "primary"
              : "grey";

          return {
            name: `${record.firstName} ${record.lastName}`,
            start: new Date(
              currentYear,
              birthDate.getMonth(),
              birthDate.getDate(),
            ),
            color: color,
            uid: record.user.uid,
            timed: false,
          };
        });
    },
    upcomingBirthdays() {
      const calendarDate = new Date(this.calendarFocus);
      const calendarMonth = calendarDate.getMonth();
      const calendarYear = calendarDate.getFullYear();

      return this.records
        .filter((record) => record.birthdate)
        .map((record) => {
          const birthDate = record.birthdate.toDate
            ? record.birthdate.toDate()
            : new Date(record.birthdate);

          // Create birthday in the calendar's displayed year
          const birthdayInMonth = new Date(
            calendarYear,
            birthDate.getMonth(),
            birthDate.getDate(),
          );

          const age = calendarYear - birthDate.getFullYear();
          const today = new Date();
          const daysUntil = Math.floor(
            (birthdayInMonth - today) / (1000 * 60 * 60 * 24),
          );

          return {
            ...record,
            nextBirthday: birthdayInMonth,
            daysUntil,
            age,
            birthMonth: birthDate.getMonth(),
          };
        })
        .filter((record) => record.birthMonth === calendarMonth)
        .sort((a, b) => a.nextBirthday.getDate() - b.nextBirthday.getDate());
    },
    divisionsLegend() {
      // Get unique divisions with their colors
      const divisionMap = new Map();

      this.records
        .filter((r) => r.division && r.division.id)
        .forEach((record) => {
          if (!divisionMap.has(record.division.id)) {
            divisionMap.set(record.division.id, {
              id: record.division.id,
              title: record.division.title,
              shortTitle: record.division.shortTitle,
              color: this.divisionColors[record.division.id] || "grey",
            });
          }
        });

      return Array.from(divisionMap.values()).sort((a, b) =>
        a.title.localeCompare(b.title),
      );
    },
    birthdaysByWeek() {
      const weeks = {};

      this.upcomingBirthdays.forEach((birthday) => {
        const weekNumber = this.getWeekNumber(birthday.nextBirthday);
        if (!weeks[weekNumber]) {
          // Get the Monday of this week
          const weekStart = this.getWeekStart(birthday.nextBirthday);
          const weekEnd = new Date(weekStart);
          weekEnd.setUTCDate(weekStart.getUTCDate() + 6);

          // Format dates using UTC to avoid timezone issues
          const startStr = `${String(weekStart.getUTCDate()).padStart(
            2,
            "0",
          )}.${String(weekStart.getUTCMonth() + 1).padStart(2, "0")}.`;
          const endStr = `${String(weekEnd.getUTCDate()).padStart(
            2,
            "0",
          )}.${String(weekEnd.getUTCMonth() + 1).padStart(2, "0")}.`;

          weeks[weekNumber] = {
            weekNumber,
            weekLabel: `KW ${weekNumber} (${startStr} – ${endStr})`,
            birthdays: [],
          };
        }
        weeks[weekNumber].birthdays.push(birthday);
      });

      return Object.values(weeks).sort((a, b) => a.weekNumber - b.weekNumber);
    },
    calendarMonthYear() {
      const date = new Date(this.calendarFocus);
      const options = { month: "long", year: "numeric" };
      return date.toLocaleDateString("de-DE", options);
    },
    calendarMonthName() {
      const date = new Date(this.calendarFocus);
      const options = { month: "long" };
      return date.toLocaleDateString("de-DE", options);
    },
  },
  watch: {
    viewMode(newValue) {
      // Update URL when view mode changes
      if (this.$route.query.display !== newValue) {
        this.$router
          .replace({
            query: { ...this.$route.query, display: newValue },
          })
          .catch(() => {});
      }
    },
    "$route.query.display"(newValue) {
      // Update viewMode when URL changes (e.g., browser back/forward)
      if (newValue && this.viewMode !== newValue) {
        this.viewMode = newValue;
      }
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      const hasContactPermission =
        this.$store.getters["organization/checkPermissionByID"]("5.per.co.re"); // MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CONTACT_read
      console.log(hasContactPermission);

      this.$store.dispatch(`${MEMBER_MANAGEMENT}${GET_PERSONNEL_RECORDS}`, {
        organizationId: this.$route.params.organizationId,
        includeContactData: hasContactPermission,
      });
    },
    startRecordCreation() {
      if (this.helpers.recordCreation.formIsValid) {
        this.helpers.recordCreation.loading = true;

        const callFunction = functions.httpsCallable(
          "memberManagement-createPersonnelRecordFromInput",
        );
        console.log({
          organizationId: this.$route.params.organizationId,
          firstName: this.helpers.personnelRecordBaseData.firstName,
          lastName: this.helpers.personnelRecordBaseData.lastName,
          personnelNumber: this.helpers.personnelRecordBaseData.personnelNumber,
          status: this.helpers.personnelRecordBaseData.status,
          division: this.helpers.personnelRecordBaseData.division,
        });
        callFunction({
          organizationId: this.$route.params.organizationId,
          firstName: this.helpers.personnelRecordBaseData.firstName,
          lastName: this.helpers.personnelRecordBaseData.lastName,
          personnelNumber: this.helpers.personnelRecordBaseData.personnelNumber,
          status: this.helpers.personnelRecordBaseData.status,
          division: this.helpers.personnelRecordBaseData.division,
        });
        callFunction()
          .then((result) => {
            console.log(result.data);
            if (result.data.success) {
              this.toggleRecordCreationDialog();
              (this.helpers.personnelRecordBaseData = {
                firstName: null,
                lastName: null,
                personnelNumber: null,
                status: null,
                division: null,
              }),
                (this.helpers.recordCreation.loading = false);
              this.helpers.recordCreation.snackbar.model = true;
              this.helpers.recordCreation.snackbar.text =
                "Datensatz für Eingabe erfolgreich erstellt";
            } else {
              this.helpers.recordCreation.loading = false;
              this.helpers.recordCreation.errorMessage =
                "Fehler: Versuche es später erneut.";
            }
          })
          .catch((error) => {
            this.helpers.recordCreation.loading = false;
            console.error(error.errorMsg);
            console.error(error);
            this.helpers.recordCreation.errorMessage = error.message;
          });
      } else {
        alert("Fehler: Prüfe Deine Daten und versuche es erneut");
      }
    },

    toggleRecordCreationDialog() {
      this.helpers.recordCreation.dialogModel =
        !this.helpers.recordCreation.dialogModel;
    },
    routeDetails(item) {
      this.$router.push({
        name: "member-management-personnel-records-details-general",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.user.uid,
        },
      });
    },
    formatBirthdayDate(birthdate) {
      if (!birthdate) return "";
      const date = birthdate.toDate ? birthdate.toDate() : new Date(birthdate);
      const today = new Date();
      const currentYear = today.getFullYear();
      const nextBirthday = new Date(
        currentYear,
        date.getMonth(),
        date.getDate(),
      );

      if (nextBirthday < today) {
        nextBirthday.setFullYear(currentYear + 1);
      }

      const options = { day: "numeric", month: "long" };
      return nextBirthday.toLocaleDateString("de-DE", options);
    },
    formatBirthdayDateShort(birthdate) {
      if (!birthdate) return "";
      const date = birthdate.toDate ? birthdate.toDate() : new Date(birthdate);
      const options = { day: "2-digit", month: "2-digit" };
      return date.toLocaleDateString("de-DE", options);
    },
    getBirthdayBadge(daysUntil) {
      if (daysUntil === 0) {
        return { text: "Heute", color: "success" };
      } else if (daysUntil === 1) {
        return { text: "Morgen", color: "info" };
      } else if (daysUntil > 0 && daysUntil <= 7) {
        return { text: `${daysUntil}T`, color: "warning" };
      }
      return null;
    },
    getWeekNumber(date) {
      const d = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
      );
      const dayNum = d.getUTCDay() || 7;
      d.setUTCDate(d.getUTCDate() + 4 - dayNum);
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    },
    getWeekStart(date) {
      // Get Monday of the ISO week for the given date
      const d = new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
      );
      const dayNum = d.getUTCDay() || 7; // Get day number, treating Sunday as 7
      const monday = new Date(d);
      monday.setUTCDate(d.getUTCDate() - dayNum + 1); // Get Monday of the week
      return monday;
    },
    showBirthdayDetails(event) {
      const record = this.records.find((r) => r.user.uid === event.event.uid);
      if (record) {
        this.routeDetails(record);
      }
    },
    previousMonth() {
      const date = new Date(this.calendarFocus);
      date.setMonth(date.getMonth() - 1);
      this.calendarFocus = date.toISOString().substr(0, 10);
    },
    nextMonth() {
      const date = new Date(this.calendarFocus);
      date.setMonth(date.getMonth() + 1);
      this.calendarFocus = date.toISOString().substr(0, 10);
    },
    filterRecords(items, search) {
      if (!search) return items;
      const searchLower = search.toLowerCase();
      return items.filter((record) => {
        const fullName = `${record.firstName} ${record.lastName}`.toLowerCase();
        const personnelNumber = record.personnelNumber
          ? record.personnelNumber.toLowerCase()
          : "";
        const dutyPosition =
          record.dutyPosition && record.dutyPosition.title
            ? record.dutyPosition.title.toLowerCase()
            : "";
        const rank =
          record.rank && record.rank.title
            ? record.rank.title.toLowerCase()
            : "";
        const division =
          record.division && record.division.title
            ? record.division.title.toLowerCase()
            : "";

        return (
          fullName.includes(searchLower) ||
          personnelNumber.includes(searchLower) ||
          dutyPosition.includes(searchLower) ||
          rank.includes(searchLower) ||
          division.includes(searchLower)
        );
      });
    },
    getGroupDisplayName(item) {
      const groupByField = this.groupBySelector.value;

      if (groupByField === "division.title") {
        return item.division && item.division.title
          ? item.division.title
          : "Keine Abteilung";
      }

      // Default fallback
      const keys = groupByField.split(".");
      let value = item;
      for (const key of keys) {
        value = value?.[key];
      }
      return value || "Keine Zuordnung";
    },
    // updateDataView(value) {
    //   this.activeDataView = value;
    // },
    // updateGroupBySelector(value) {
    //   this.groupBySelector = value;
    // },
  },
};
</script>
